import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Card, CardBody, Container, DropdownItem, FormFeedback, FormGroup, Input, Modal, Table } from "reactstrap";
import { useFormik } from "formik";
import TfBreadcrumbs from "../../components/Common/TfBreadcrumbs";
import { AddSubscriptionBreadcrumb, EditSubscriptionBreadcrumb } from "../../common/data/parties";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GET_MODULE_TYPE, } from "../../store/Global/actiontype";
import { RoleName } from "../Settings/Roles/RolesCol";
import { showErrorToast } from "../../components/Common/CustomToast";
import * as Yup from "yup";
import AccessModuleTable from "./components/AccessModuleTable";
import { postSubscriptionsSummaryData } from "../../store/Subscriptions/actions";
import { getAuthType, isObjectEmpty } from "../../components/Common/CommonLogic";
import { useLoadingBar } from '../../components/Common/ProgressBar';
import { SUBSCRIPTION_INITIALIZE, SUBSCRIPTION_LOADER_START } from "../../store/Subscriptions/actiontype";
import { getAllModuleBasedOnLogin } from "../../store/Global/actions";
import Select from "react-select";
import { industryType } from "../../common/data/settings";
import SelectBox from "../../components/GlobalComponent/SelectComponent";
import FormInputField from "../../components/GlobalComponent/InputComponent";
import ButtonGroup from "../../components/GlobalComponent/ButtonGroupComponent";


const AddEditSubscriptions = () => {
    const { start, complete, decrease, increase } = useLoadingBar({
        height: 3,
    });
    const navigateState = useLocation();
    const navigate = useNavigate();
    const { roleData, moduleData, new_Permission, module_loader, role_data_By_id } = useSelector((state) => state.globalReducer);
    const [permissions, setPermissions] = useState(navigateState?.state?.permissions ? navigateState?.state?.permissions : []);
    const selectAllRefs = useRef(navigateState?.state?.data?.subscriptionModuleMaps ? navigateState?.state?.data?.subscriptionModuleMaps : []);
    const selectAllPermissions = useRef(navigateState?.state?.data?.subscriptionModuleMaps ? navigateState?.state?.data?.subscriptionModuleMaps : []);
    const { subscriptionsLoader } = useSelector((state) => state.subscriptionsReducer);
    const [disabled, setDisabled] = useState(true);
    const [disableInput, setDisableInput] = useState(false);
    const [disableButton, setDisableButton] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [cancelUpdate, setCancelUpdate] = useState(false);
    const [resetAllCheckBox, setResetAllCheckBox] = useState(false);
    const dispatch = useDispatch();

    let newPermission = [];

    useEffect(() => {
        dispatch(getAllModuleBasedOnLogin(getAuthType() !== '1'));
        console.log(navigateState?.state?.data);
        if (navigateState?.state?.data !== undefined) {
            setDisableInput(true);
            setDisableButton(true);
            setDisabled(false);
            setIsUpdate(true);
            setCancelUpdate(true);
            navigateState?.state?.data?.subscriptionModuleMaps.map((item) => {
                newPermission.push({
                    moduleId: item.moduleId,
                });
            });
            setPermissions(newPermission);
        }
    }, [dispatch])

    const viewPopupHandler = (data) => {
        //console.log("popup");
    };

    function checkPermission(module) {
        //console.log("checkPermission", module);
        const permission = selectAllPermissions.current
            .filter(data => data.moduleId === getRowModuleId(module))
            .some(data => data.moduleId === getRowModuleId(module));
        return permission;
    }

    useEffect(() => {
        //console.log(new_Permission);
        selectAllRefs.current = []
        selectAllRefs.current = new_Permission;
    }, [new_Permission])



    const onClickSave = async (event, rowData) => {
        setResetAllCheckBox(true);
        console.log(event, rowData);
        if (rowData) {
            if (event) {
                newPermission.push({
                    moduleId: getRowModuleId(rowData),
                });
            } else {
                newPermission = newPermission.filter(permission => !(
                    permission.moduleId === getRowModuleId(rowData)
                ));
            }
            setPermissions(newPermission);
        }
        console.log(newPermission)
    }

    const getRowModuleId = (rowData) => {
        if (rowData.hasOwnProperty("parentModuleId")) {
            return rowData.id;
        } else {
            return rowData.id;
        }
    }

    const roleFormik = useFormik({
        initialValues: {
            subscriptionCode: navigateState?.state?.data?.subscriptionCode,
            subscriptionName: navigateState?.state?.data?.subscriptionName || "",
            //version: navigateState?.state?.data?.version || 0,
            isInvitedBy: navigateState?.state?.data?.isInvitedBy || false,
            isDefault: navigateState?.state?.data?.isDefault || false,
            industryType: navigateState?.state?.data?.industryType || 'AGENT',
        },
        validationSchema: Yup.object({
            subscriptionCode: Yup.string().required("Please enter subscription code"),
            subscriptionName: Yup.string().required("Please select subscription name"),
        }),
        onSubmit: (values) => {
            //console.log(values);
            setDisableInput(true);
            setDisabled(false);
            setDisableButton(true);
        },
    });

    const resetSubscriptions = () => {
        setDisableInput(false);
        setDisabled(true);
    }

    const onModuleCancel = () => {
        setResetAllCheckBox(false);
        subscriptionsGroupingColumns.
            newPermission = [];
    }

    const onModuleSubmit = async () => {
        if (permissions.length > 0) {
            dispatch({ type: SUBSCRIPTION_LOADER_START });
            start();
            let subscriptionData = {
                id: navigateState?.state?.data?.id || "",
                version: navigateState?.state?.data?.version || "0",
                subscriptionCode: roleFormik.values.subscriptionCode,
                subscriptionName: roleFormik.values.subscriptionName,
                isDefault: roleFormik.values.isDefault,
                isInvitedBy: roleFormik.values.isInvitedBy,
                industryType: roleFormik.values.industryType,
                subscriptionModuleMaps: permissions
            }
            //console.log("onModuleSubmit", subscriptionData);
            dispatch(postSubscriptionsSummaryData(subscriptionData));
        } else {
            showErrorToast("Please select at-least one module");
        }
    };

    useEffect(() => {
        //console.log(subscriptionResponse);
        if (subscriptionsLoader === true) {
            start();
        }
        if (subscriptionsLoader === false) {
            dispatch({ type: SUBSCRIPTION_INITIALIZE });
            navigate('/network/subscriptions');
            setTimeout(() => {
                complete();
            }, 1000);
        }
    }, [subscriptionsLoader])


    const subscriptionsGroupingColumns = useMemo(() => ([
        {
            Header: "Modules",
            accessor: "label",
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <RoleName cellProps={cellProps} viewPopupHandler={viewPopupHandler} />
                );
            },
        },
        {
            Header: "Sub Modules",
            accessor: "modules",
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <>
                        {cellProps.row.original.subModules?.map((module, index) => (
                            <div key={index}>
                                {module.name}
                                {index !== cellProps.row.original.subModules?.length - 1 && <hr className="module-divider" />}
                            </div>
                        ))}
                    </>
                );
            },
        },
        {
            Header: "Access",
            accessor: "access",
            filterable: true,
            width: 2,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <>
                        {cellProps.row.original.subModules && cellProps.row.original.subModules.length > 0 ? cellProps.row.original.subModules?.map((module, index) => (
                            <div key={index}>
                                <Input
                                    type="checkbox"
                                    className="custom-checkbox"
                                    onChange={(e) => { onClickSave(e.target.checked, module) }}
                                    defaultChecked={checkPermission(module) || false}
                                />
                                {index !== cellProps.row.original.subModules?.length - 1 && <hr className="module-divider" />}
                            </div>
                        )) :
                            <Input
                                type="checkbox"
                                className="custom-checkbox"
                                onChange={(e) => onClickSave(e.target.checked, cellProps.row.original)}
                                defaultChecked={checkPermission(cellProps.row.original) || false}
                            />
                        }
                    </>
                );
            },
        }
    ]), []);


    return (
        <>
            <div className="page-content settings_users_wrapper">
                <Container fluid>
                    <div className="main_freight_wrapper">
                        <div className="tf_top_breadcrumb_rate_wrap">
                            <TfBreadcrumbs breadcrumb={isUpdate ? EditSubscriptionBreadcrumb : AddSubscriptionBreadcrumb} />
                            <div className="form-container">
                                <button type="button" className="btn border mb-3" onClick={() => { navigate(-1); }} > Back </button>
                                <div className="row">
                                    <Card>
                                        <CardBody>
                                            <div className="row ">
                                                <div className="col-12 col-md-4 mb-4">
                                                    <FormInputField
                                                        formik={roleFormik}
                                                        type={"text"}
                                                        placeholder={"Subscription Code"}
                                                        name={"subscriptionCode"}
                                                        label={"Subscription Code"}
                                                        showValidation={true}
                                                        disabled={disableInput} />
                                                </div>

                                                <div className="col-12 col-md-4 mb-4">
                                                    <FormInputField
                                                        formik={roleFormik}
                                                        type={"text"}
                                                        placeholder={"Subscription Name"}
                                                        name={"subscriptionName"}
                                                        label={"Subscription Name"}
                                                        showValidation={true}
                                                        onChange={(e) => {
                                                            setDisableButton(false);
                                                            roleFormik.setFieldValue("subscriptionName", e.target.value);
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="row ">
                                                <div className="col-12 col-md-4 mb-2">
                                                    <SelectBox
                                                        placeholder={'Select company type...'}
                                                        name={'industryType'}
                                                        label={'Company Type'}
                                                        formik={roleFormik}
                                                        options={industryType}
                                                        onChangeOverride={(e, formik) => {
                                                            roleFormik.setFieldValue("industryType", e.value);
                                                        }}
                                                        isDisabled={disableInput}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 mb-3 align-content-center">
                                                    <div className="d-flex align-items-center gap-2 mt-4">
                                                        <Input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            onChange={(e) => roleFormik.setFieldValue("isDefault", e.currentTarget.checked)}
                                                            defaultChecked={roleFormik.values.isDefault}
                                                            id="setDefaultCheckbox"
                                                        />
                                                        <label htmlFor="setDefaultCheckbox" className="form-check-label mb-0">
                                                            Set As Default
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 mb-3 align-content-center">
                                                    <div className="d-flex align-items-center gap-2 mt-4">
                                                        <Input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            onChange={(e) => roleFormik.setFieldValue("isInvitedBy", e.currentTarget.checked)}
                                                            defaultChecked={roleFormik.values.isInvitedBy}
                                                            id="setInvitedByCheckbox"
                                                        />
                                                        <label htmlFor="setInvitedByCheckbox" className="form-check-label mb-0">
                                                            Set By Invite
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-center mt-3">
                                                    <ButtonGroup
                                                        showCancel={true}
                                                        showSubmit={true}
                                                        onCancel={() => resetSubscriptions()}
                                                        onSubmit={roleFormik.handleSubmit}
                                                        submitText="Save"
                                                        cancelBtnProps={{ disabled: cancelUpdate }}
                                                        isSubmitting={disableButton}
                                                    />
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>

                                <AccessModuleTable
                                    columns={subscriptionsGroupingColumns}
                                    data={moduleData || []}
                                    customPageSize={25555}
                                    loader={module_loader || false}
                                    onModuleCancel={onModuleCancel}
                                    onModuleSave={onModuleSubmit}
                                    enableAction={disabled}
                                    isUpdate={isUpdate}
                                />
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}

export default AddEditSubscriptions;
